// import $ from 'jquery';
import { gsap } from 'gsap';

export default class UiScroll {
  constructor() {
    this.scroll = '.scroll';
  }
  setScroll(num) {
    if (num >= 6) {
      gsap.to(this.scroll, { opacity: 0, duration: 1 });
    } else {
      gsap.to(this.scroll, { opacity: 1, duration: 1 });
    }
  }
}
